import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../../features/contexts/ThemeContext';
import './contact-us.css';

const FEEDBACK_OPTIONS = [
  { value: "feedback", label: "Feedback" },
  { value: "report", label: "Report" },
  { value: "appeal", label: "Appeal" },
  { value: "complaint", label: "Complaint" },
  { value: "billing", label: "Billing" },
  { value: "general-help", label: "General Help" },
  { value: "verification-help", label: "Verification Help" },
  { value: "dmca-help", label: "DMCA Help" },
  { value: "payout-help", label: "Payout Help" },
  { value: "referral-help", label: "Referral Help" },
];

const CustomDropdown = React.forwardRef(({ value, onChange, error }, ref) => {
  const { isDarkMode } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = React.useRef(null);

  // Expose focus method through ref
  React.useImperativeHandle(ref, () => ({
    focus: () => {
      if (dropdownRef.current) {
        dropdownRef.current.focus();
      }
    },
    scrollIntoView: (options) => {
      if (dropdownRef.current) {
        dropdownRef.current.scrollIntoView(options);
      }
    }
  }));

  const handleSelect = useCallback((val) => {
    onChange(val);
    setIsOpen(false);
  }, [onChange]);

  const toggleDropdown = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleDropdown();
    }
  }, [toggleDropdown]);

  const dropdownClasses = [
    'custom-dropdown-button',
    'custom-dropdown-button',
    value ? 'has-value' : '',
    error ? 'error' : ''
  ].filter(Boolean).join(' ');

  return (
    <div ref={ref} className="custom-dropdown-wrapper custom-dropdown-wrapper">
      <label
        onClick={toggleDropdown}
        className="custom-dropdown-label custom-dropdown-label"
      >Select Reason</label>

      <div
        ref={dropdownRef}
        onClick={toggleDropdown}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        name="feedbackReason"
        data-field-name="feedbackReason"
        className={dropdownClasses}
      >
        {FEEDBACK_OPTIONS.find((o) => o.value === value)?.label || "Select a reason"}
        <i
          className="fa-solid fa-chevron-down custom-dropdown-chevron custom-dropdown-chevron"
        ></i>
      </div>

      {isOpen && (
        <ul className="custom-dropdown-list custom-dropdown-list">
          {FEEDBACK_OPTIONS.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt.value)}
              className="custom-dropdown-item custom-dropdown-item"
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

CustomDropdown.displayName = "CustomDropdown";

CustomDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.object,
};

export default CustomDropdown;
